import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 50 },
  show: { opacity: 1, y: 0, transition: { duration: 1, ease: [0.22, 1, 0.36, 1] } },
};

export const About = () => {
  const { t } = useLanguage();
  const stats = [
    { n: "30+", l: t("about.stat1") },
    { n: "15", l: t("about.stat2") },
    { n: "∞", l: t("about.stat3") },
  ];
  return (
    <section id="about" data-testid="about-section" className="relative py-28 sm:py-40">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            className="lg:col-span-7"
          >
            <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-8">
              {t("about.eyebrow")}
            </p>
            <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl leading-tight text-white">
              {t("about.title")}
              <span className="gold-gradient-text italic">{t("about.titleAccent")}</span>
            </h2>
            <div className="mt-10 space-y-6 text-[#A0ABC0] text-base sm:text-lg font-light leading-relaxed max-w-2xl">
              <p>{t("about.p1")}</p>
              <p>{t("about.p2")}</p>
              <p>{t("about.p3")}</p>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-8 max-w-lg">
              {stats.map((s) => (
                <div key={s.l} data-testid={`stat-${s.l}`}>
                  <p className="font-serif-lux text-4xl sm:text-5xl gold-gradient-text">{s.n}</p>
                  <p className="mt-2 text-xs uppercase tracking-widest text-[#A0ABC0]">{s.l}</p>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            className="lg:col-span-5 relative"
          >
            <div className="relative overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_design-showcase-1404/artifacts/56mwjnwc_20160407_201832.webp"
                alt="Design intérieur signature — ambiance lumineuse Medernach Lionel Designer"
                className="w-full h-[560px] object-cover"
              />
              <div className="absolute inset-0 border border-[#D4AF37]/30" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-[#0A1420] border border-[#D4AF37]/40 px-8 py-6 hidden sm:block">
              <p className="font-serif-lux italic text-xl text-white">{t("about.badge1")}</p>
              <p className="text-[#D4AF37] text-xs uppercase tracking-widest mt-1">
                {t("about.badge2")}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
